export default {"src":"/_next/static/media/GroupButtonBrown.3b77662a.svg","height":18,"width":16,"blurWidth":0,"blurHeight":0};